<template>
  <div>
    <!-- Header -->
    <div class="header py-7 py-lg-4 pt-lg-9"></div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5" style="max-width:1340px !important">
      <!-- <img v-if="brokerObj" :src="getLogo" class="navbar-brand-img" alt="Sidebar logo"
        style="padding-bottom: 30px; width: 230px; padding-left: 15px;" /> -->
      <div>
        <base-header class="pb-6 bg-primary">
          <b-row class="align-items-center py-4">
            <b-col> </b-col>
          </b-row>
        </base-header>
        <div class="px-0 px-sm-3 mt--12">
          <b-card no-body class="mb-4 px-0">

            <div class="container-fluid mt-12" v-if="formModel != null && !quoteNoLongerEditable">

              <edit-quote-form formMode="edit" @emailCustomer="emailCustomer" @nextStep="nextStep"
                :editModel="formModel" />

            </div>
            <div class="container-fluid px-3 motor-continue-quote-thankyou-panel"
              v-else-if="formModel != null && quoteNoLongerEditable">
              <b-card class="uBind">
                <h2>Thank you</h2>
                <div>
                  Thank you, this quote is no longer editable. Please contact <a
                    href="mailto:hello@transportprotect.com.au">hello@transportprotect.com.au</a> if any changes need to
                  be made.
                </div>
              </b-card>
            </div>
            <!-- <div id="ubind-iframe"></div> -->
          </b-card>








        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { quoteFormMethods } from "../helpers/quoteForm";
import { GlobalStore } from "../globalStore";
import { appFunctions } from "../helpers/appFunctions";
import { motorQuoteStatus } from "../constants/motorQuoteStatus";
import EditQuoteForm from "../views/motorLive/EditQuoteForm.vue";

export default {
  name: "MotorContinueQuote",
  props: {
    productType: {
      type: String,
      required: true,
      validator: value =>
        ["ride-protect", "mercurien-light-commercial"].includes(value)
    }
  },
  data() {
    return {
      ubindQuoteId: "",
      isReady: false,
      htmlString: "",
      brokerObj: null,
      formModel: null,
      // Snapshot of whether the quote was already in a terminal state when the
      // page first loaded. We only want to show the "no longer editable"
      // message for users returning to the link later — not immediately after
      // they click Submit/Bind in this session.
      initiallyNotEditable: false,
    };
  },
  methods: {
    emailCustomer() { },
    nextStep() { }
  },
  computed: {
    quoteNoLongerEditable() {
      return this.initiallyNotEditable;
    },
    getLogo() {
      return "https://yihq-storage.sgp1.digitaloceanspaces.com/production/1685929387562-logo_full_cropped.png";
    },
    getQuoteId() {
      return this.ubindQuoteId;
    },
    getProduct() {
      return this.productType === "ride-protect"
        ? GlobalStore.ubindClientInfo.rideShareProduct
        : GlobalStore.ubindClientInfo.product;
    },
    getTenant() {
      return GlobalStore.ubindClientInfo.tenantId;
    },
    getEnvironment() {
      return GlobalStore.ubindClientInfo.environment;
    }
  },
  async mounted() {

    console.log("PSC loaded");

    //   const appconfig = await appFunctions.lookupGetConfig();

    //   GlobalStore.ubindClientInfo.organisationId =
    //     appconfig.ubindInfo.organisationId;
    //   GlobalStore.ubindClientInfo.environment = appconfig.ubindInfo.environment;
    //   GlobalStore.ubindClientInfo.tenantId = appconfig.ubindInfo.tenantId;
    //   GlobalStore.ubindClientInfo.product = appconfig.ubindInfo.product;
    //   GlobalStore.ubindClientInfo.rideShareProduct =
    //     appconfig.ubindInfo.rideShareProduct;

    //   // put this in to handle link from ubind generated save email
    //   // there is also some logic in the main.js to handle this.
    //  // if (this.$route.params.id == "ubind") {
    const quoteId = this.$route.params["id"];

    //     console.log(quoteId)

    // appFunctions
    //   .crud_customerPolicy("getCombinedById", {
    //     id: "67e6300a37ad22215b4a7dc7"
    //   })
    //   .then(resp => {
    //     console.log(resp);
    //   })

    //if (this.productType === "ride-protect") {
    quoteFormMethods.getMLQuoteFromGuid(quoteId).then(resp => {

      console.log(resp);

      this.formModel = resp;
      //this.formModel = resp.data;

      const terminalStatuses = [
        motorQuoteStatus.quoteReferredBasedOnUnderwritingQuestions,
        motorQuoteStatus.quoteDeclinedBasedOnUnderwritingQuestions,
        motorQuoteStatus.policyBound,
      ];
      if (resp && terminalStatuses.includes(resp.status)) {
        this.initiallyNotEditable = true;
        return;
      }

      this.formModel.Customer_policy_status = "in_progress";

      var policyObj = this.formModel.Data_obj.messageData.policy;

      // this.formModel.privacyNotice1 = this.formModel.privacyNotice1 || true;
      //   this.formModel.privacyNotice2 = this.formModel.privacyNotice2 || false;
      //   this.formModel.privacyNotice3 = this.formModel.privacyNotice3 || false;
      //   this.formModel.privacyNotice4 = this.formModel.privacyNotice4 || false;
      //   this.formModel.privacyNotice5 = this.formModel.privacyNotice5 || false;
      //   this.formModel.privacyNotice6 = this.formModel.privacyNotice6 || true;
      //   this.formModel.privacyNotice7 = this.formModel.privacyNotice7 || false;

      this.formModel.privacyNotice1 = policyObj.sharedPolicySubproduct.disclosureDetails.bankruptcy == "YES" ? true : false;
      this.formModel.privacyNotice2 = policyObj.sharedPolicySubproduct.disclosureDetails.claimDenied == "YES" ? true : false;
      this.formModel.privacyNotice3 = policyObj.sharedPolicySubproduct.disclosureDetails.criminalConviction == "YES" ? true : false;
      this.formModel.privacyNotice4 = policyObj.sharedPolicySubproduct.disclosureDetails.thermalCoalMines == "YES" ? true : false;
      //this.formModel.privacyNotice5 = this.formModel.privacyNotice5 || false;
      //this.formModel.privacyNotice6 = this.formModel.privacyNotice6 || false;
      this.formModel.dangerousGoods1 = policyObj.commercialMotorSubproduct.dangerousGoodsDisclosure.bulkDangerousGoodsCarried == "YES" ? true : false;


      //Have to get these from sentObj for some reason for now
      this.formModel.situationStreet = this.formModel.Sent_quote.messageData.policy.sharedLiabilitySubproduct.generalBusinessDetails.addressOfPrincipalSituation.addressLine1;
      this.formModel.situationCity = this.formModel.Sent_quote.messageData.policy.sharedLiabilitySubproduct.generalBusinessDetails.addressOfPrincipalSituation.suburb;
      this.formModel.situationState = this.formModel.Sent_quote.messageData.policy.sharedLiabilitySubproduct.generalBusinessDetails.addressOfPrincipalSituation.state;
      this.formModel.situationPostcode = this.formModel.Sent_quote.messageData.policy.sharedLiabilitySubproduct.generalBusinessDetails.addressOfPrincipalSituation.postcode;

      this.formModel.primaryGoods = policyObj.commercialMotorSubproduct.vehiclesAndGoods.primaryGood;
      this.formModel.additionalGoods = (
        policyObj.commercialMotorSubproduct.vehiclesAndGoods.listOfAdditionalGoods || []
      )
        .map((item) => item && item.additionalGood && item.additionalGood.additionalGoods)
        .filter(Boolean);

      this.formModel.lengthOfOperating = policyObj.commercialMotorSubproduct.generalMotorDetails.yearsOfOperation;

      this.formModel.vehicles = policyObj.commercialMotorSubproduct.vehiclesAndGoods.listOfVehicles;

      this.formModel.businessDesc = policyObj.sharedLiabilitySubproduct.generalBusinessDetails.businessDescription;


      this.formModel.radiusOfOperation = policyObj.commercialMotorSubproduct.generalMotorDetails.radiusOfOperation;


      this.formModel.atFault = policyObj.commercialMotorSubproduct.motorDisclosure.atFault == "YES" ? true : false;
      this.formModel.claimLodged = policyObj.commercialMotorSubproduct.motorDisclosure.claimLodged == "YES" ? true : false;
      this.formModel.convictedAlcoholDrug = policyObj.commercialMotorSubproduct.motorDisclosure.convictedAlcoholDrug == "YES" ? true : false;
      this.formModel.licenceSuspension = policyObj.commercialMotorSubproduct.motorDisclosure.licenceSuspension == "YES" ? true : false;

      this.formModel.primeDriverUnderExperience = policyObj.commercialMotorSubproduct.motorDisclosure.primeDriverUnderExperience == "YES" ? true : false;
      this.formModel.rigidDriverUnderExperience = policyObj.commercialMotorSubproduct.motorDisclosure.rigidDriverUnderExperience == "YES" ? true : false;

      this.formModel.vehicleUsageOffRoad = policyObj.commercialMotorSubproduct.vehiclesAndGoods.vehicleUsageOffRoad == "YES" ? true : false;
      this.formModel.vehicleUsagePassengerHired = policyObj.commercialMotorSubproduct.vehiclesAndGoods.vehicleUsagePassengerHired == "YES" ? true : false;
      this.formModel.vehicleUsageSpecialFitOut = policyObj.commercialMotorSubproduct.vehiclesAndGoods.vehicleUsageSpecialFitOut == "YES" ? true : false;

      this.formModel.currentlyInsured = policyObj.commercialMotorSubproduct.generalMotorDetails.currentlyInsured == "YES" ? true : false;;

      this.formModel.nswSdExemption = policyObj.commercialMotorSubproduct.vehiclesAndGoods.nswSdExemption == "YES" ? true : false;


      this.formModel.reasonNotInsured = "1";

      //this.formModel.acceptDOD = this.formModel.acceptDOD || false;

      this.formModel.quote_created_date = this.$moment(new Date()).format("YYYY-MM-DD");

      this.formModel.priorClaims = false;

      this.formModel.listOfDangerousGoods = [];
      this.formModel.listOfClaims = [
        //{
        //   "claim": {
        //     "reference": "ec8f3b4f-b2b2-456e-a4ae-90fe90957b3c",
        //     "dateOfLoss": "2025-11-18",
        //     "totalIncurred": 12345.00,
        //     "descriptionOfLoss": "hrthrhrht",
        //     "claimProductSection": "CM"
        //   }
        // }
      ];




      //document.location.href =
      //"/ps-live/continueQuote/" + quoteId;
    });
    //   } else {
    //     quoteFormMethods.getLCQuoteFromUbindGuid(ubindId).then(resp => {
    //       document.location.href =
    //         "/lightCommercial/continueQuote/" +
    //         resp.quoteData.Customer_policy_guid;
    //     });
    //   }
    // } else {
    //   const quoteRes =
    //     this.productType === "ride-protect"
    //       ? await quoteFormMethods.getRSQuoteFromGuid(this.$route.params.id)
    //       : await quoteFormMethods.getLCQuoteFromGuid(this.$route.params.id);

    //   this.ubindQuoteId = quoteRes.quoteData.Ubind_quote_id;

    //   GlobalStore.brokerObj = quoteRes.brokerData;
    //   this.brokerObj = quoteRes.brokerData;

    //   let embedOptions = {
    //     tenant: GlobalStore.ubindClientInfo.tenantId,
    //     //organisation: appconfig.ubindInfo.organisationId,
    //     product:
    //       this.productType === "ride-protect"
    //         ? GlobalStore.ubindClientInfo.rideShareProduct
    //         : GlobalStore.ubindClientInfo.product,
    //     environment: appconfig.ubindInfo.environment,
    //     quoteId: this.ubindQuoteId
    //   };

    //   let embedElement = document.getElementById("ubind-iframe");

    //   _uBindInjector.loadWebFormElement(embedElement, embedOptions);
    // }

    //console.log(GlobalStore.ubindClientInfo);
  },
  components: {
    EditQuoteForm
  }
};
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5,
li,
p {
  color: black !important;
}

img {
  width: 350px;
  height: auto;
}

.sideNotes {
  font-size: 0.9rem;
  margin-top: 28px;
}

.financierMessage {
  color: red;
  font-style: italic;
}

@media (max-width: 767px) {
  .bordered-table-left {
    border-style: solid;
    border-width: 1px 1px 0px 1px;
    padding: 5px;
  }

  .bordered-table-right {
    border-style: solid;
    border-width: 1px 1px 1px 1px;
    padding: 5px;
  }

  .bordered-table-right .row {
    border-style: solid !important;
    border-width: 0px 0px 1px 0px !important;
    margin: 0px -5px 0px -5px;
    padding: 0px;
  }

  .bordered-table-right .row:last-child {
    border-style: none !important;
  }
}

@media (min-width: 767px) {
  .bordered-table-left {
    border-style: solid;
    border-width: 1px 1px 1px 1px;
    padding: 5px;
  }

  .bordered-table-right {
    border-style: solid;
    border-width: 1px 1px 1px 0px;
    padding: 5px;
  }

  .bordered-table-right .row {
    border-style: solid !important;
    border-width: 0px 0px 1px 0px !important;
    margin: 0px -5px 0px -5px;
    padding: 0px;
  }

  .bordered-table-right .row:last-child {
    border-style: none !important;
  }

  .my-radio> ::after {
    border: 1px solid var(--primary);
    border-radius: 100%;
  }

  .my-checkbox> ::after {
    border: 1px solid var(--primary);
    border-radius: 25%;
  }

  .my-invalid-feedback {
    color: #fb6340;
    width: 100%;
    font-size: 80%;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .logo_image {
    width: 300px;
    image-rendering: -webkit-optimize-contrast;
  }
}

.ubind-product {
  margin: 0px 15px 0px 15px;
}

.container {
  padding-left: 0px;
  padding-right: 0px;
}

.container-fluid {
  padding-left: 0px;
  padding-right: 0px;
}

.motor-continue-quote-thankyou-panel {
  margin-top: -1.75rem;
  position: relative;
  z-index: 2;
}
</style>
